const ClientStatusLabels = { "Fee Setting": "Fee Setting/Pre-Appointment Checks" };

export { ClientStatusLabels };
